import { atom } from "recoil";
import { Profile } from "../models/User";

const ProfileState = atom<Profile | null>({
  key: "Profile",
  default: null,
});

export default ProfileState;
